import InactiveUsers from './InactiveUsers';

export default InactiveUsers;
